export * from './lib/contact-product-assignment.component';
